import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { documentTitlePrefixAtom } from '@frontend/atoms';

import { useBadgeCount } from './useBadgeCount';

export function useNotificationTitle() {
  const { data: badgeCount } = useBadgeCount({ grouped: true });
  const setPrefix = useSetAtom(documentTitlePrefixAtom);

  useEffect(() => {
    const count = badgeCount ?? 0;
    setPrefix(count > 0 ? `(${count}) ` : '');

    return () => setPrefix('');
  }, [badgeCount, setPrefix]);
}
